import { Button, styled } from '@mui/material'

export const FrameworkButton = styled(Button)({
    height: '48px',
    width: '157px',
    fontSize: '16px',
    letterSpacing: 0,
    lineHeight: '18px'
})
